import React from 'react';
import PropTypes from 'prop-types';

import { logError } from 'commons/logger';

class ErrorTryCatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logError(error, { message: 'Error happened:', info });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return null;
  }
}

ErrorTryCatch.propTypes = {
  children: PropTypes.node,
};

export default ErrorTryCatch;
